import ChallengesApi from '@/api/ChallengesApi';
import _ from 'lodash';
import moment from 'moment';
import DDLogs from '@/DDLogs';

async function hasActiveOrFutureImOnItChallenge() {
  try {
    const challenges = await ChallengesApi.getChallengesDataForCustomer();
    return !!_.chain(challenges)
      .map(({ type, endDate }) => { return { type, endDate: moment(endDate) }; })
      .find(({ type, endDate }) => type === 'dailyTaskBased' && endDate >= moment().startOf('day').toDate())
      .value();
  } catch (error) {
    DDLogs.log('Something went wrong when fetching challenges data for customer', { error });
    return false;
  }
}

export default hasActiveOrFutureImOnItChallenge;
